import React, { useContext, useMemo } from 'react';

import { ContextProps, ClientExperimentsContextProviderProps } from './ClientExperimentsContext.types';

export const ClientExperimentsContext = React.createContext<ContextProps | undefined>(undefined);

export const ClientExperimentsContextProvider = ({
    children,
    inLynxesIdentificationIllustrationExperimentGroupB = false,
}: ClientExperimentsContextProviderProps) => {
    const contextValue = useMemo(
        () => ({
            inLynxesIdentificationIllustrationExperimentGroupB,
        }),
        [inLynxesIdentificationIllustrationExperimentGroupB]
    );

    return <ClientExperimentsContext.Provider value={contextValue}>{children}</ClientExperimentsContext.Provider>;
};

export const useClientExperimentsContext = () => {
    const value = useContext(ClientExperimentsContext);

    if (value === undefined) {
        throw new Error('useClientExperimentsContext must be used within a ClientExperimentsContext.Provider');
    }

    return value;
};
